import { alpha, Box, Stack, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import type { SwipeableComponentRef } from "web_myplann/Shared/Hooks/useSwipeable";

type Props = {
	length: number;
	defaultValue?: number;
	onClick: (val: number, direction?: "left" | "right") => void;
};

export const CarrouselDots = forwardRef<SwipeableComponentRef, Props>(
	({ length, defaultValue, onClick }, ref) => {
		const { palette } = useTheme();
		const [value, setValue] = useState(defaultValue ?? 0);

		useEffect(() => {
			setValue(defaultValue ?? 0);
		}, [defaultValue]);

		useImperativeHandle(ref, () => ({
			swipeLeft: () => {
				const newVal = value > 0 ? value - 1 : length - 1;

				setValue(newVal);
				onClick(newVal, "left");
			},
			swipeRight: () => {
				const newVal = value > length - 2 ? 0 : value + 1;

				setValue(newVal);
				onClick(newVal, "right");
			},
		}));

		return (
			<Stack direction="row" gap={0.4}>
				{Array.from({ length }).map((_, i) => (
					<Box
						// biome-ignore lint/suspicious/noArrayIndexKey: Static carousel dots with no unique identifier
						key={i}
						p={0.5}
						borderRadius="9999px"
						sx={{
							backgroundColor:
								i === value
									? palette.darkmodeText.white
									: alpha(palette.darkmodeText.white, 0.4),
						}}
						onClick={() => {
							setValue(i);
							onClick(i);
						}}
					/>
				))}
			</Stack>
		);
	},
);
